import React, { createContext, useContext } from 'react';

//external packages
import PubNub from 'pubnub';

//constants
import { PUBNUB_PUBLISH_KEY, PUBNUB_SUBSCRIBE_KEY } from './constants';

//utilities
import { getCookie } from 'utils';

const pubnub = new PubNub({
  publishKey: PUBNUB_PUBLISH_KEY,
  subscribeKey: PUBNUB_SUBSCRIBE_KEY,
  uuid: getCookie('user_id') || '4b24a4e2-f6d8-11ec-b939-0242ac120002',
});

const pubnubContext = createContext();

const PubnubProvider = ({ children }) => {
  return <pubnubContext.Provider value={pubnub}>{children}</pubnubContext.Provider>;
};

const usePubnub = () => {
  const context = useContext(pubnubContext);
  if (context === undefined) {
    throw new Error('usePubnub must be used within a PubnubProvider');
  }
  return context;
};

export { PubnubProvider, usePubnub };
